var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{class:_vm.classes,attrs:{"type":"button","disabled":_vm.isDisabled},on:{"click":_vm.handleChange}},[_vm._t("default",null,{"date":_vm.date,"parsedDate":_vm.parsedDate,"disabled":_vm.isDisabled,"selected":_vm.isSelected,"isToday":_vm.isToday})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }